/**
 * ResponsiveCard - Card adattiva per diverse dimensioni schermo
 */

import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  CardActions,
  Box,
  useTheme,
  useMediaQuery,
  SxProps,
  Theme,
} from '@mui/material';

interface ResponsiveCardProps {
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  sx?: SxProps<Theme>;
  elevation?: number;
  variant?: 'elevation' | 'outlined';
}

const ResponsiveCard: React.FC<ResponsiveCardProps> = ({
  title,
  subtitle,
  children,
  actions,
  sx = {},
  elevation = 1,
  variant = 'elevation',
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Card
      elevation={elevation}
      variant={variant}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 2,
        ...sx,
      }}
    >
      {(title || subtitle) && (
        <CardHeader
          title={title}
          subheader={subtitle}
          titleTypographyProps={{
            variant: isMobile ? 'h6' : 'h5',
            fontWeight: 600,
          }}
          subheaderTypographyProps={{
            variant: isMobile ? 'body2' : 'body1',
            color: 'text.secondary',
          }}
          sx={{
            pb: isMobile ? 1 : 2,
            '& .MuiCardHeader-content': {
              overflow: 'hidden',
            },
          }}
        />
      )}
      
      <CardContent
        sx={{
          flexGrow: 1,
          p: isMobile ? 2 : 3,
          '&:last-child': {
            pb: isMobile ? 2 : 3,
          },
        }}
      >
        {children}
      </CardContent>
      
      {actions && (
        <CardActions
          sx={{
            p: isMobile ? 1 : 2,
            pt: 0,
            flexWrap: 'wrap',
            gap: 1,
          }}
        >
          {actions}
        </CardActions>
      )}
    </Card>
  );
};

export default ResponsiveCard;
